import { Vector3,Math as MathUtils,Box3,AmbientLight } from 'three';

import bidello,{ component } from 'bidello';
import * as helpers from './bidello';
import settings from './settings';
import * as dat from 'dat.gui';
import camera from './camera';
import scene from './scene';
import renderer from './renderer';
import CssRenderer from './cssRenderer';
import postfx from './postfx/postfx';
import {Observatory} from "./models/Observatory";
import {RootView} from "./models/RootView";
import {States} from "../services/StateManager";
import TWEEN from 'three/examples/jsm/libs/tween.module.min'
import {getCenter} from "./utils/bounding";
import {meshLoader} from "./utils/meshloader";
import {Planetarium} from "./models/Planetarium";
import {assets} from "../services/assets";
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js';
import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader.js';


export class ThreeApp extends component(){
    init() {




        document.body.appendChild(renderer.domElement);
        document.body.appendChild(CssRenderer.domElement);
        CssRenderer.domElement.style.pointerEvents = "none"
        this.observatory = new Observatory();
        this.planetarium =  new Planetarium();


        this.rootView = new RootView();
        this.rootView.setActiveState();
        this.rootView.setDefaultState();

        this.ambientLight = new AmbientLight();

        const loader = new GLTFLoader(assets);
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath("/decoders/draco/");
        loader.setDRACOLoader(dracoLoader);
        loader.load(require("/assets/media/meshes/scene.glb"),(scene)=>{
            console.log(scene.scene,"console.log ('gltf loade',scene)")
            this.observatory.setMesh(scene.scene);
            this.rootView.setMesh(scene.scene);
        });


        scene.add(this.ambientLight);
        scene.add(this.rootView)
        scene.add(this.observatory)
        scene.add(this.planetarium);


    }

    run(){


    }

    onRaf() {

        postfx.render(scene, camera);

        CssRenderer.render(scene,camera)
        //renderer.render(scene, camera);
        TWEEN.update();
    }

    onLoadEnd() {
        console.log('finished loader!');
    }

    onStateChange(state){


        //if (state.state == States.root.DEFAULT_SATE ) this.setIntroState ();
        //if (state.state == "visit_state" ) this.setObservatoryState ();
        //if (state.state == "solar_system_state" ) this.setSolarSystemState ();
        //if (state.state == "planet_state" ) this.setPlanetState (state);
        //if (state.state == "content_open_state") this.setContentOpenState()
        //if (state.state == "content_close_state") this.setContentCloseState()

    }

    setObservatoryState (){

        //this.obs.visible = true;
        this.rootView.visible = false;

    }

    setIntroState (){

        camera.reset();
        //this.obs.visible = false;
        this.rootView.visible = true;
        this.rootView.setActiveState();


    }

    setPlanetState(data){


        this.ambientLight.intensity = 0;


    }





}

